import { render, staticRenderFns } from "./TaskDeviceDetail.vue?vue&type=template&id=10bdee6c&scoped=true&"
import script from "./TaskDeviceDetail.vue?vue&type=script&lang=js&"
export * from "./TaskDeviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./TaskDeviceDetail.vue?vue&type=style&index=0&id=10bdee6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bdee6c",
  null
  
)

export default component.exports